import type { PartialWithFieldValue } from 'firebase/firestore'
import {
  collectionGroup,
  query,
  where,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { StreamInterface } from 'tricklejs/dist/types'
import { modelListStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { SectionAssignmentOutput } from '../../models/SectionAssignmentOutput'
import type { FirestoreSectionAssignmentOutput } from './schema'
import { schema, writeSchema } from './schema'

const converter: FirestoreDataConverter<FirestoreSectionAssignmentOutput> = {
  toFirestore: (
    data: PartialWithFieldValue<FirestoreSectionAssignmentOutput>
  ) => {
    writeSchema.partial().parse(data)
    return data
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

export const getSectionAssignmentOutputs = (
  repository: FirebaseRepository,
  params: { sectionId: string }
): StreamInterface<SectionAssignmentOutput[]> => {
  const ref = collectionGroup(
    repository.firestore,
    'assignment_output'
  ).withConverter(converter)

  const q = query(ref, where('sectionId', '==', params.sectionId))
  return modelListStream(repository, q, SectionAssignmentOutput)
}
